import { createAuthClient } from 'better-auth/react';
import { twoFactorClient, organizationClient } from 'better-auth/client/plugins';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3001';

export const authClient = createAuthClient({
  baseURL: `${API_URL}/api/backoffice/auth`,
  plugins: [
    twoFactorClient(),
    organizationClient(),
  ],
});

export const { signIn, signUp, signOut, useSession } = authClient;
